// extracted by mini-css-extract-plugin
export default {"reviews-gallery":"ReviewsGallery_reviews-gallery__kF2qC"};